import React, { useState } from 'react';
import { Link } from 'react-router-dom';

const PageLanding = () => {
    const [email, setEmail] = useState("");
    const [error, setError] = useState("");
    const [loading, setLoading] = useState(false);
    const [successMessage, setSuccessMessage] = useState("");
    const [privacyEmailCopied, setPrivacyEmailCopied] = useState(false);

    const contactEmail = "hello@onewriter.app";

    const isValidEmail = (value) => {
        const atIndex = value.indexOf("@");
        const dotIndex = value.lastIndexOf(".");
        return atIndex > 0 && dotIndex > atIndex + 1 && dotIndex < value.length - 1;
    };

    const handleEnterApp = async () => {
        if (!isValidEmail(email)) {
            setError("Please enter a valid email address.");
            return;
        }

        setError("");
        setSuccessMessage("");
        setLoading(true);

        try {
            const response = await fetch('/api/auth/request', {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({ email })
            });

            const data = await response.json();

            if (!response.ok) {
                setError(data.error || "Failed to send magic link.");
            } else {
                setSuccessMessage("Check your email! We've sent you a magic link to sign in.");
                setEmail("");
            }
        } catch (err) {
            setError("Something went wrong. Please try again.");
            console.error(err);
        } finally {
            setLoading(false);
        }
    };

    const handleKeyDown = (e) => {
        if (e.key === 'Enter') handleEnterApp();
    };

    const handlePrivacyEmailClick = (e) => {
        e.stopPropagation();
        navigator.clipboard.writeText(contactEmail).then(() => {
            setPrivacyEmailCopied(true);
            setTimeout(() => setPrivacyEmailCopied(false), 4000);
        });
    };

    return (
        <div style={{
            minHeight: "100vh",
            backgroundColor: "white",
            padding: "20px",
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            textAlign: "center"
        }}>
            <h1 style={{
                fontFamily: "'American Typewriter', 'Courier New', Courier, monospace",
                fontSize: "3.0rem",
                marginBottom: "10px",
                marginLeft: "10px"
            }}>OneWriter<sup style={{ fontSize: "0.6em" }}>&#174;</sup></h1>

            <div style={{ lineHeight: "1.3", marginBottom: "16px", fontWeight: "600", fontFamily: "Arial, Helvetica, sans-serif" }}>
                <p style={{ margin: "2px 0", fontStyle: "italic" }}>It's a Word Processor</p>
                <p style={{ margin: "2px 0", fontStyle: "italic" }}>and a Spreadsheet</p>
                <p style={{ margin: "2px 0", fontStyle: "italic", marginLeft: "-5px" }}>
                    <span style={{ fontSize: "1.5em", verticalAlign: "-0.2em" }}>&ldquo;</span>
                    <span style={{ display: "inline-block", width: "3px" }} />
                    IN ONE APP
                    <span style={{ display: "inline-block", width: "1px" }} />
                    <span style={{ fontSize: "1.5em", verticalAlign: "-0.2em" }}>&rdquo;</span>
                </p>
            </div>

            <div style={{
                maxWidth: "320px",
                fontSize: "14px",
                color: "#444",
                lineHeight: "1.6",
                marginBottom: "20px",
                textAlign: "justify",
                hyphens: "auto",
                WebkitHyphens: "auto"
            }}>
                <p style={{ margin: "0" }}>
                    Bring efficiency and productivity gains to your writing projects &mdash; AI powered, <span style={{ fontSize: "1.03em", fontWeight: "700" }}>human-focused</span>, <span style={{ fontSize: "1.08em", fontWeight: "700", fontStyle: "italic" }}>infinite creativity.</span>
                </p>
            </div>

            <div style={{
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
                gap: "12px",
                width: "100%",
                maxWidth: "320px"
            }}>
                <p style={{ margin: "0", fontSize: "14px", color: "#444" }}>
                    You can use OneWriter for FREE, right now.</p>

                <p
                    onMouseEnter={(e) => e.currentTarget.style.color = "#000"}
                    onMouseLeave={(e) => e.currentTarget.style.color = "#888"}
                    style={{ margin: "0", marginTop: "-8px", fontSize: "10px", color: "#888", transition: "color 0.2s ease", cursor: "default" }}
                >
                    Works best with Chrome browser for desktop.
                </p>

                <input
                    type="email"
                    placeholder="Please enter a valid email address..."
                    value={email}
                    onChange={(e) => setEmail(e.target.value)}
                    onKeyDown={handleKeyDown}
                    disabled={loading}
                    style={{
                        padding: "10px",
                        width: "100%",
                        borderRadius: "8px",
                        border: "1px solid #ccc",
                        fontSize: "13px",
                        boxSizing: "border-box",
                        textAlign: "center"
                    }}
                />

                <button
                    onClick={handleEnterApp}
                    disabled={loading}
                    onMouseEnter={(e) => {
                        if (!loading) {
                            e.target.style.backgroundColor = "#333";
                            e.target.style.borderColor = "#333";
                        }
                    }}
                    onMouseLeave={(e) => {
                        if (!loading) {
                            e.target.style.backgroundColor = "#000";
                            e.target.style.borderColor = "#000";
                        }
                    }}
                    onMouseDown={(e) => {
                        if (!loading) {
                            e.target.style.backgroundColor = "#555";
                            e.target.style.transform = "scale(0.98)";
                        }
                    }}
                    onMouseUp={(e) => {
                        if (!loading) {
                            e.target.style.backgroundColor = "#333";
                            e.target.style.transform = "scale(1)";
                        }
                    }}
                    style={{
                        padding: "10px 20px",
                        width: "100%",
                        borderRadius: "8px",
                        border: "1px solid #000",
                        backgroundColor: "#000",
                        color: "#fff",
                        fontSize: "14px",
                        cursor: loading ? "not-allowed" : "pointer",
                        transition: "background-color 0.15s ease, transform 0.1s ease"
                    }}
                >
                    {loading ? "Sending..." : "...and click to start writing"}
                </button>
            </div>

            {error && <div style={{ color: "red", marginTop: "10px" }}>{error}</div>}
            {successMessage && <div style={{ color: "green", marginTop: "10px", maxWidth: "320px" }}>{successMessage}</div>}

            {/* Privacy Policy click reveal */}
            <div style={{
                maxWidth: "320px",
                fontSize: "14px",
                color: "#444",
                lineHeight: "1.6",
                marginBottom: "30px",
                textAlign: "justify",
            }}>
                <p style={{ marginTop: "10px", fontSize: "10px", color: "#444", textAlign: "center" }}>
                    <span
                        style={{ position: "relative", display: "inline-block" }}
                        onClick={(e) => {
                            const popup = e.currentTarget.querySelector('.privacy-popup');
                            if (popup) {
                                const isVisible = popup.style.opacity === '1';
                                popup.style.opacity = isVisible ? '0' : '1';
                                popup.style.pointerEvents = isVisible ? 'none' : 'auto';
                            }
                        }}
                        onMouseEnter={(e) => {
                            const label = e.currentTarget.querySelector('.privacy-label');
                            if (label) {
                                label.style.color = '#000';
                                label.style.textDecoration = 'underline';
                            }
                        }}
                        onMouseLeave={(e) => {
                            const label = e.currentTarget.querySelector('.privacy-label');
                            if (label) {
                                label.style.color = '#888';
                                label.style.textDecoration = 'none';
                            }
                            const popup = e.currentTarget.querySelector('.privacy-popup');
                            if (popup) {
                                popup.style.opacity = '0';
                                popup.style.pointerEvents = 'none';
                            }
                        }}
                    >
                        <span
                            className="privacy-label"
                            style={{
                                color: "#888",
                                cursor: "pointer",
                                textDecoration: "none",
                                transition: "color 0.2s ease",
                            }}
                        >
                            Our Privacy Policy
                        </span>
                        <span
                            className="privacy-popup"
                            style={{
                                position: "absolute",
                                top: "calc(100% + 8px)",
                                left: "50%",
                                transform: "translateX(-50%)",
                                background: "white",
                                border: "1px solid #ccc",
                                borderRadius: "8px",
                                padding: "12px 14px",
                                width: "300px",
                                fontSize: "10px",
                                color: "#444",
                                lineHeight: "1.6",
                                textAlign: "justify",
                                hyphens: "none",
                                WebkitHyphens: "none",
                                boxShadow: "0 4px 12px rgba(0,0,0,0.1)",
                                opacity: 0,
                                pointerEvents: "none",
                                transition: "opacity 0.3s ease",
                                zIndex: 10,
                                whiteSpace: "normal",
                            }}
                        >
                            <span style={{
                                position: "absolute",
                                top: "-6px",
                                left: "50%",
                                transform: "translateX(-50%) rotate(45deg)",
                                width: "10px",
                                height: "10px",
                                background: "white",
                                borderLeft: "1px solid #ccc",
                                borderTop: "1px solid #ccc",
                            }} />
                            Your OneWriter projects belong to you. We do not save or view your projects. The valid email address you share can be used for product awareness management.{" "}
                            {privacyEmailCopied ? (
                                <strong><u>hello@OneWriter.app</u> copied to clipboard</strong>
                            ) : (
                                <>Please email us if you have any additional inquiries:{" "}
                                    <span
                                        onClick={handlePrivacyEmailClick}
                                        style={{ textDecoration: "underline", cursor: "pointer" }}
                                    >
                                        hello@OneWriter.app
                                    </span></>
                            )}
                        </span>
                    </span>
                </p>
            </div>

            <p style={{ marginTop: "40px", fontSize: "12px", color: "#444" }}>
                Created by Jamie Kayam | App About It © {new Date().getFullYear()}
            </p>
        </div>
    );
};

export default PageLanding;